import React from 'react';

export default function HomePage() {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Stilet Residence</h1>
      <p>Dobrodošli u naš apartman!</p>
      <div style={{ border: '1px solid black', padding: '20px', margin: '20px' }}>
        <h3>Luksuzni Apartman</h3>
        <p>Prelijep pogled na more.</p>
        <p><strong>Cijena: 50€</strong></p>
      </div>
    </div>
  );
}

